import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
// The password-reset link (/reset-password/<token>) carries a working token in the address bar, and production sends
// page addresses to Google Analytics and page addresses and session replays to Sentry (boot/sentryio.js). A script at
// the top of index.template.html takes the token out of the address before either starts and keeps it for this tab
// only (sessionStorage, so a reload still works; window.__resetToken when storage is refused); this boot file, first
// in the boot order, does the same should the address still carry it (#39). ResetPasswordPage reads it with
// resetToken() and forgets it when the password is set, the link turns out invalid or the page is left.
var KEY = 'reset-token';
var PATH = /\/reset-password\/([^/?#]+)\/?$/; // without sessionStorage (a private window that refuses it): this page load only

var kept = window.__resetToken || null;

var keep = function keep(token) {
  kept = token;

  try {
    sessionStorage.setItem(KEY, token);
  } catch (e) {}
};

export var resetToken = function resetToken() {
  try {
    return sessionStorage.getItem(KEY) || kept;
  } catch (e) {
    return kept;
  }
};
export var forgetResetToken = function forgetResetToken() {
  kept = null;
  window.__resetToken = null;

  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {}
};
export default (function () {
  var match = window.location.pathname.match(PATH);

  if (!match) {
    // the app opened on another page in this tab (the reset page left by a full page load): the token goes
    if (!/\/reset-password\/?$/.test(window.location.pathname)) forgetResetToken();
    return;
  }

  var token = match[1];

  try {
    token = decodeURIComponent(token);
  } catch (e) {}

  keep(token);
  var path = window.location.pathname.replace(PATH, '/reset-password');
  window.history.replaceState(window.history.state, '', path + window.location.search + window.location.hash);
});